import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DevisStatut, IDevisResponse } from 'src/app/shared/models/devis';
import { DevisService } from '../devis.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';

@Component({
  selector: 'app-devis-retour-dialog',
  templateUrl: './devis-retour-dialog.component.html',
  styleUrls: ['./devis-retour-dialog.component.less']
})
export class DevisRetourDialogComponent {

  form: FormGroup;
  saving = false;

  constructor(
    private fb: FormBuilder,
    private devisService: DevisService,
    private snackbarService: SnackbarService,
    private authService: AuthenticationService,
    public dialogRef: MatDialogRef<DevisRetourDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDevisResponse
  ) {
    this.form = this.fb.group({
      motifRetour: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  onConfirmer(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.saving = true;
    const { motifRetour } = this.form.value;
    const userRole = this.authService.getUser()?.profile as string ?? undefined;

    this.devisService.updateStatut(this.data.devisId, DevisStatut.CREE, undefined, undefined, undefined, motifRetour, userRole).subscribe({
      next: () => {
        this.snackbarService.openSnackBar('Devis remis en état "Créé"');
        this.dialogRef.close(true);
      },
      error: () => {
        this.snackbarService.openSnackBar('Erreur lors du retour en arrière', 'error-snack-bar');
        this.saving = false;
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
